export const authViews = { LOGIN: 1, REGISTER: 2, FORGOTPASSWORD: 3, TWOFACTORENROLLMENT: 4, TOTPSIGNIN: 5 };
export const controlTypes = { COUNTER: 1, STOPWATCH: 2, FREETEXT: 3, DATALIST: 4, SCANNER: 5, CAMERA: 6, EXTERNALAPI: 7 };
export const externalApiTypes = { DATA: 1, STOPWATCH: 2, NUMERIC: 3, ENUM: 4 };
export const externalApiEnumBehaviorTypes = { ANCHOR: 1, STICKY: 2 };
export const dataListTypes = { NAME: 0 };
export const ExternalApiFilterTypes = { NAME: 0, COMPANY: 1, APITYPE: 2, BEHAVIOR: 3 };
export const Roles = { ADMIN: 1, BACKOFFICEADMIN: 2, BACKOFFICEUSER: 3, DATAANALIST: 4 };
export const RoleNames = [
  { name: "Admin", id: 1, color: "rgb(124, 181, 121)" },
  { name: "Backoffice-admin", id: 2, color: "rgb(124, 181, 121)" },
  { name: "Backoffice-user", id: 3, color: "rgb(212, 214, 75)" },
  { name: "Data analist", id: 4, color: "rgb(245, 132, 69)" },
];

export const ProjectFilter = { ALLPROJECTS: 1, MYPROJECTS: 2 };

export const TableView = { GRID: 1, LIST: 2 };

export const valueTypeCodes = { VA: 1, NVA: 2, W: 3 };

export const crudTypes = { CREATE: 1, READ: 2, UPDATE: 3, DELETE: 4 };

export const graphTypes = { YAMAZUMI: 1, TIMELINE: 2, FINANCIAL: 3, PROFITLOSS: 4, OUTPUT: 5, INSIGHTS: 6, SIMULATIONS: 7 };

export const simulationScenarioTypes = { ACCOUNTS: 1, PRICE_DEFINITIONS: 2 };

export const currencies = { DOLLAR: 1, EURO: 2, POUND: 3, RUPEE: 4 };
export const currencySymbols = { DOLLAR: "$", EURO: "€", POUND: "£", RUPEE: "₹" };

export const subscriptionTiers = { FLAGSTONE: -1, TRYOUT: 1, PROFESSIONAL: 2, ENTERPRISE: 3 };

export const timeLineVisualisationTypes = { SPLIT: 1, LINEAREVENTS: 2 };

export const profitLossResultColumns = [
  { id: 1, name: "companyName", title: "Customer", className: "table-column-companyName" },
  { id: 2, name: "projectName", title: "Project" },
  { id: 3, name: "resourceName", title: "Registration point" },
  { id: 4, name: "description", title: "Description" },
  { id: 4, name: "accountCategoryName", title: "Category" },
  { id: 4, name: "accountName", title: "Account" },
  { id: 5, name: "signedEventPrice", title: "Event Price" },
  { id: 6, name: "keyValue", title: "Key" },
  { id: 10, name: "startHour", title: "Start Hour" },
  { id: 11, name: "startDayOfWeek", title: "Day" },
  { id: 7, name: "startTime", title: "Start Time" },
  { id: 12, name: "durationInMinutes", title: "Duration (min)" },
  { id: 8, name: "sessionValues", title: "Session values" },
  { id: 9, name: "running", title: "Finished" },
  { id: 10, name: "action", title: "Action", className: "table-column-actions" },
];

export const resultColumns = [
  { id: 1, name: "companyName", title: "Customer", className: "table-column-companyName" },
  { id: 2, name: "projectName", title: "Project" },
  { id: 3, name: "resourceName", title: "Registration point" },
  { id: 4, name: "description", title: "Description" },
  { id: 5, name: "valueType", title: "Value type" },
  { id: 6, name: "measurementValue", title: "Value" },
  { id: 12, name: "signedEventPrice", title: "Event Price" },
  { id: 7, name: "keyValue", title: "Key" },
  { id: 8, name: "commentText", title: "Comment" },
  { id: 13, name: "startHour", title: "Start Hour" },
  { id: 14, name: "startDayOfWeek", title: "Day" },
  { id: 15, name: "durationInMinutes", title: "Duration (min)" },
  { id: 9, name: "startTime", title: "Start Time" },
  { id: 10, name: "sessionValues", title: "Session values" },
  { id: 11, name: "running", title: "Finished" },
  { id: 12, name: "action", title: "Action", className: "table-column-actions" },
];

export const resultTableColumnExtensions = [
  { columnName: "companyName", align: "left" },
  { columnName: "projectName", align: "left" },
  { columnName: "resourceName", align: "left" },
  { columnName: "description", align: "left" },
  { columnName: "valueType", align: "center", width: 140 },
  { columnName: "measurementValue", align: "left" },
  { columnName: "keyValue", align: "left" },
  { columnName: "startHour", align: "right" },
  { columnName: "startDayOfWeek", align: "left" },
  { columnName: "durationInMinutes", align: "right" },
  { columnName: "startTime", align: "center", width: 100 },
  { columnName: "sessionValues", align: "left" },
  { columnName: "running", align: "center", width: 60, sortingEnabled: false, allowSorting: false },
  { columnName: "action", align: "center", width: 60, sortingEnabled: false, allowSorting: false, groupingEnabled: false },
];

export const measurementsTableColumnExtensions = [
  { columnName: "companyName", align: "left" },
  { columnName: "projectName", align: "left" },
  { columnName: "resourceName", align: "left" },
  { columnName: "description", align: "left" },
  { columnName: "valueType", align: "center", width: 140 },
  { columnName: "measurementValue", align: "left" },
  { columnName: "keyValue", align: "left" },
  { columnName: "durationInMinutes", align: "right" },
  { columnName: "startTime", align: "center", width: 100 },
  { columnName: "running", align: "center", width: 60, sortingEnabled: false, allowSorting: false },
  { columnName: "action", align: "center", width: 90, sortingEnabled: false, allowSorting: false, groupingEnabled: false },
];

export const resultGroupingColumnExtensions = [
  { columnName: "companyName", groupingEnabled: true },
  { columnName: "projectName", groupingEnabled: true },
  { columnName: "resourceName", groupingEnabled: true },
  { columnName: "description", groupingEnabled: true },
  { columnName: "valueType", groupingEnabled: true },
  { columnName: "measurementValue", groupingEnabled: true },
  { columnName: "keyValue", groupingEnabled: true },
  { columnName: "startTime", groupingEnabled: true },
  { columnName: "sessionValues", groupingEnabled: true },
  { columnName: "running", columnGroupingEnabled: false },
  { columnName: "", columnGroupingEnabled: false },
];

export const filteringStateColumnExtensions = [
  { columnName: "companyName", width: "10%", filteringEnabled: true },
  { columnName: "projectName", width: "10%", filteringEnabled: true },
  { columnName: "resourceName", width: "10%", filteringEnabled: true },
  { columnName: "description", width: "10%", filteringEnabled: true },
  { columnName: "valueType", width: "10%", filteringEnabled: true },
  { columnName: "measurementValue", width: "10%", filteringEnabled: true },
  { columnName: "signedEventPrice", width: "10%", filteringEnabled: true },
  { columnName: "keyValue", width: "10%", filteringEnabled: true },
  { columnName: "commentText", width: "10%", filteringEnabled: true },
  { columnName: "startHour", width: "10%", filteringEnabled: true },
  { columnName: "startDayOfWeek", width: "10%", filteringEnabled: true },
  { columnName: "startTime", width: "10%", filteringEnabled: false },
  { columnName: "sessionValues", width: "10%", filteringEnabled: true },
  { columnName: "running", width: "10%", filteringEnabled: false },
  { columnName: "", filteringEnabled: false },
];

// Filter operations
export const numericFilterOperations = {
  equal: "equal",
  notEqual: "notEqual",
  greaterThan: "greaterThan",
  greaterThanOrEqual: "greaterThanOrEqual",
  lessThan: "lessThan",
  lessThanOrEqual: "lessThanOrEqual",
};

export const sumMessages = {
  sum: "Som",
  contains: "Bevat",
  notContains: "Bevat niet",
  startsWith: "Start met",
  endsWith: "Eindigd met",
  equal: "Is gelijk aan",
  notEqual: "Is niet gelijk aan",
};

export const tableMessages = {
  sum: "Som",
  contains: "Bevat",
  noData: "Geen registraties beschikbaar.",
};

// colors to differentiate the different registration points
export const registrationPointColors = [
  // colors that are easily distinguishable
  "#1f77b4", // blue
  "#ff7f0e", // orange
  "#2ca02c", // green
  "#d62728", // red
  "#9467bd", // purple
  "#8c564b", // brown
  "#e377c2", // pink
  "#7f7f7f", // grey
  "#bcbd22", // yellow
  "#17becf", // cyan
];

// Filter types
export const ProjectFilterTypes = { CUSTOMER: 0, PROJECT_NAME: 1, LOCATION_NAME: 2, DESCRIPTION: 3, VALUETYPE: 4, KEYVALUE: 5, EVENTCOUNT: 6, STARTDATE: 7, ENDDATE: 8, GENERAL: 9 };
export const GraphFilterTypes = { GENERAL: 0 };
export const SubscriberFilterTypes = { NAME: 0 };
export const PriceDefinitionFilterTypes = { NAME: 0, CODE: 1, SEARCH: 2, COMPANY: 3, ACCOUNT: 4 };
export const PriceBundleFilterTypes = { NAME: 0, REFERENCE: 1, SEARCH: 2, COMPANY: 3 };
export const AccountFilterTypes = { NAME: 0, SEARCH: 1, COMPANY: 2 };
export const DataListFilterTypes = { NAME: 0, COMPANY: 1 };

// Event types
export const eventTypes = {
  EVENT_BASED: 1,
  TIME_BASED: 2,
  RECURRING: 3,
};

// CostBundleTypes
export const costBundleTypes = {
  EVENT: 1,
  TIME: 2,
  RECURRING: 3,
};

// FlowBox
export const flowBoxDeviceStatus = { REGISTERED: 1, ACTIVE: 2, DEREGISTERED: 3, INACTIVE: 4, AVAILABLE_TO_CONNECT: 5, SETUP: 6, PENDING_CONFIGURATION: 7 };
export const flowBoxButtonAction = { MEASURE: 0, START: 1, STOP: 2, TOGGLE: 3, SUBTRACT: 4, LOG_DURATION: 5 };
export const FlowBoxFilterTypes = { NAME: 0, STATUS: 1 };
